export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin-test': '测试',
  'menu.crm': '客户关系管理',
  'menu.tb-company-manage': '客户管理',
  'menu.customer': '客户管理',
  'menu.quote': '报价管理',
  //公海
  'menu.public-pool': '公海管理',
  'menu.order': '订单管理',
  'menu.sample': '样品管理',
  'menu.contact': '联系人管理',
  'menu.reports': '销售报表',
  'menu.product': '产品管理',
  'menu.product.tb-product-manage': '产品管理',
  'menu.product.tb-category-manage': '分类管理',
  'menu.admin-test.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.dashboard.home': '控制台',
  'menu.pam': '授权管理',
  'menu.pam.home': '授权首页',
  'menu.pam.dashboard': '授权统计',
  'menu.pam.license': '许可证管理',
  'menu.pam.device': '设备管理',
  'menu.pam.timeToken': '时间令牌管理',
  'menu.pam.tracing': '链路追踪管理',
  'menu.pam.deploy': '发布管理',
  'menu.pam.deploy.server': '部署服务器',
  'menu.pam.deploy.cleanup-config': '磁盘清理配置',
  'menu.pam.deploy.task': '发布任务',
  'menu.pam.deploy.registry': '镜像仓库',
  'menu.pam.deploy.ssl-cert': 'SSL 证书',
  'menu.pam.deploy.git-repo': 'Git 仓库',
  'menu.pam.deploy.build-config': '构建配置',
  'menu.pam.deploy.build': '镜像构建',
  'menu.pam.deploy.migration': '设备凭证迁移',
  'menu.pam.security': '安全管理',
  'menu.pam.security.dashboard': '安全监控看板',
  'menu.pam.security.alerts': '安全事件',

  'menu.pam.security.hardware-change': '硬件变更日志',
  'menu.pam.security.device-diagnostic': '设备诊断信息',
  'menu.diagnosisManager': '智能诊断管理',
  'menu.requestSummary': '请求汇总',
  'menu.logs': '日志管理',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.admin': '系统管理',
  'menu.admin.user-manage': '用户管理',
  'menu.admin.post-manage': '岗位管理',
  'menu.admin.dept-manage': '部门管理',
  'menu.admin.role-manage': '角色管理',
  'menu.admin.menu-manage': '菜单管理',
  'menu.admin.api-manage': '接口管理',
  'menu.admin.config-settings': '参数配置',
  'menu.admin.config-manage': '配置管理',
  'menu.admin.config-manage.info': '配置信息',
  'menu.admin.config-manage.settings': '系统设置',
  'menu.admin.dict-manage': '字典管理',

  'menu.admin.log-manage': '日志管理',
  'menu.admin.log-manage.requestlog': '请求日志',
  'menu.admin.log-manage.operatelog': '操作日志',
  'menu.admin.log-manage.abnormallog': '异常日志',
  'menu.todo': '我的任务',
  'menu.process.tpl': '模版管理',
  'menu.process.task': '任务管理',
  'menu.process.examine': '审批管理',

  'menu.workorder': '工单管理',
  'menu.workorder.all': '所有工单',
  'menu.workorder.my': '我的工单',
  'menu.workorder.related': '相关工单',
  'menu.workorder.upcoming': '我的工单', //'我的待办',
  'menu.workorder.examine': '提交申请',
  'menu.workorder.list': '提交申请',
  'menu.workorder.manage': '审批管理',
  'menu.workorder.manage.workflow': '流程管理',
  'menu.workorder.info': '工单信息',
  'menu.dev-tools': '系统工具',
  'menu.dev-tools.form': '程序设计',

  'menu.dev-tools.info': '表单详情',
  'menu.dev-tools.agent': '代理客户端',
  'menu.dev-tools.form-design': '表单设计',

  'menu.advanced': '工单详情',
  'menu.jobs': '定时任务',
  'menu.jobs.jobs-manage': '任务管理',

  'menu.cms': '内容管理',
  'menu.cms.friendlink-manage': '友情链接',
  'menu.cms.article-manage': '文章管理',
  'menu.cms.menu-manage': '导航管理',
  'menu.cms.page-manage': '页面管理',

  'menu.blocks': '积木管理',
  'menu.blocks.blocks-info-manage': '管理模块',
  'menu.blocks.projects': '积木市场',

  'menu.notice': '消息中心',
  'menu.admin.system-notice-manage': '通知公告',
  'menu.notice.user-system-notice-manage': '我的消息',

  'menu.demo': '示例',
  'menu.demo.upload': '上传示例',
  'menu.demo.tbM': '主附表示例',
  'menu.demo.tb-m-manage': '主附表示例',

  // PAM 菜单（title 字段英文 key → 中文显示名）
  'menu.pam.security.operate-log': '操作日志',
  'menu.pam.time-token': '时间令牌',
  'menu.pam.security.security-dashboard': '安全看板',
  'menu.pam.security.alert-rules': '规则配置',
  'menu.pam.security.weekly-report': '运营周报',

  // 代码自动插入标记(勿删)
};
